export default function AppUpdateNotice({
  reloading = false,
  updated = true,
  reference = '',
  detail = '',
}) {
  const runtimeFailure = !reloading && updated === false;
  const title = reloading
    ? 'Updating Signal Bridge…'
    : (runtimeFailure ? 'This page stopped' : 'Signal Bridge was updated');
  const body = reloading
    ? 'This page is loading the latest version.'
    : (runtimeFailure
      ? 'Signal Bridge hit an error while showing this page. Your Home was not cleared.'
      : 'Reload this page to continue.');
  return (
    <div style={{ padding: 32, maxWidth: 440, margin: '48px auto', fontFamily: 'Arial, sans-serif', color: '#1f2937' }}>
      <h1 style={{ fontSize: 20, fontWeight: 650, margin: '0 0 8px' }}>
        {title}
      </h1>
      <p style={{ margin: '0 0 16px', color: '#4b5563' }}>
        {body}
      </p>
      {runtimeFailure && detail ? (
        <p style={{ margin: '0 0 8px', color: '#1f2937' }}>{detail}</p>
      ) : null}
      {runtimeFailure && reference ? (
        <p style={{ margin: '0 0 16px', color: '#4b5563' }}>{`Reference ${reference}`}</p>
      ) : null}
      {reloading ? null : (
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            background: '#2563eb',
            color: '#fff',
            border: 0,
            borderRadius: 6,
            padding: '8px 14px',
            fontSize: 14,
            cursor: 'pointer',
          }}
        >
          {runtimeFailure ? 'Try again' : 'Reload'}
        </button>
      )}
    </div>
  );
}
